import { loaderCreator } from '@/services/loaderPlugin/_base'
import { loadGtm } from '@/utils/gtm'

export default loaderCreator(() => {
  loadGtm()
})
